const state = {
  estimationList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  estimation: {},
  autoEstimation: {},

  quotationList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  quotation: {
    deviceIdx: '',
    deviceName: '',
    isChangeDevice: false,
    divMonth: '24',
    divMonthName: '24개월',
    estimateId: [],
    estimateSendView: [],
    factoryPrice: 0,
    info: '',
    creditCardCombi: 1,
    creditCardCombiName: '카드결합 또는 중고보상 제외',
    interestYn: '',
    manufacturerId: '',
    manufacturerName: '',
    modelName: '',
    planIdx: '',
    planName: '',
    policy: 0,
    policyName: '공시지원',
    price: 0,
    storeSupportMoney: 0,
    supportMoney: 0,
    supportMoneyDt: '',
    telecomId: '',
    telecomName: '',
    userId: [],
    storeName: '',
    isFromChat: false,
    isDetail: false,
    isSendChatMessage: false,
    welfareId: '',
    welfareDetail: '',
    welfareFixedAmount: 0,
    welfareFixedRate: 0,
    welfareMaxAmount: 0,
    welfareText: '',
    planPeriod: '183일',
    planTypeIdx: '',
    planTypeName: '',
    planTypePrice: 0,
    planTypeSupportMoney: 0,
    planTypeSupportMoneyDt: '',
    planVoice: '',
    planSms: '',
    planData: '',
    planVideo: '',
  },
  // 견적 요청서 모델
  estimationModel: {
    targetName: '', //대상(1:본인,2:부,3:모,4:자녀)
    targetAgeName: '', // 대상연령대(1:18세이상,2:18세이하,3:12세이하,4:모르겠음)
    target: 1, //대상(1:본인,2:부,3:모,4:자녀)
    targetAge: 1, // 대상연령대(1:18세이상,2:18세이하,3:12세이하,4:모르겠음)
    telecomId: '',
    telecomName: '',
    currentDeviceIdx: '',
    currentDeviceName: '',
    currentManufacturerId: '',
    currentManufacturerName: '',
    currentModelName: '',
    needDeviceIdx: '',
    needDeviceName: '',
    needManufacturerId: '',
    needManufacturerName: '',
    needModelName: '',
    dataUsage: 0,
    internetUsage: 0,
    period: 0,
    storeId: 0,
    telecomMaintance: 0,
    steps: 1,
    closedAt: '',
    type: 'DEFAULT',
  },
};

export default state;
